import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { IUnreadInAppMessageData } from '../types';

type InAppMessageModalProviderProps = {
  children: ReactNode;
};

type InAppMessageModalContextValue = {
  isInAppMessageSimpleModalOpen: boolean;
  setIsInAppMessageSimpleModalOpen: (open: boolean) => void;
  inAppMessageData?: IUnreadInAppMessageData;
  setInAppMessageData: (data: IUnreadInAppMessageData | undefined) => void;
};

const InAppMessageModalContext = createContext<InAppMessageModalContextValue>({
  isInAppMessageSimpleModalOpen: false,
  setIsInAppMessageSimpleModalOpen: () => null,
  inAppMessageData: undefined,
  setInAppMessageData: () => null,
});

const InAppMessageModalProvider = ({
  children,
}: InAppMessageModalProviderProps) => {
  const [isInAppMessageSimpleModalOpen, setIsInAppMessageSimpleModalOpen] =
    useState(false);
  const [inAppMessageData, setInAppMessageData] =
    useState<IUnreadInAppMessageData>();

  const value = useMemo(
    () => ({
      isInAppMessageSimpleModalOpen,
      setIsInAppMessageSimpleModalOpen,
      inAppMessageData,
      setInAppMessageData,
    }),
    [isInAppMessageSimpleModalOpen, inAppMessageData],
  );

  return (
    <InAppMessageModalContext.Provider value={value}>
      {children}
    </InAppMessageModalContext.Provider>
  );
};

const useInAppMessageModal = () => useContext(InAppMessageModalContext);

export { InAppMessageModalProvider, useInAppMessageModal };
